import { FrameInput } from '@vfit/shared/atoms';
import { forwardRef } from 'react';
import { useFrameDateInput } from './frameDateInput.hook';
import { IFrameDateInput } from './frameDateInput.models';
import * as S from './frameDateInput.style';

export const FrameDateInput = forwardRef<HTMLInputElement, IFrameDateInput>(
  ({ endDateTime, startDateTime, variant = 'long', ...rest }, ref) => {
    const { day, frameInputVariant, timeRange } = useFrameDateInput({
      endDateTime,
      startDateTime,
      variant,
    });

    if (!day || !timeRange) {
      return null;
    }

    return (
      <FrameInput ref={ref} {...rest} control={false} variant={frameInputVariant}>
        {variant === 'long' ? (
          <div>
            <S.Day>{day}</S.Day>
            <S.TimeRange variant={variant}>{timeRange}</S.TimeRange>
          </div>
        ) : (
          <S.TimeRange variant={variant}>{timeRange}</S.TimeRange>
        )}
      </FrameInput>
    );
  }
);

